<app-system-message></app-system-message>
<!-- Search input component, shown when mainContent is 'clients' -->
<div [ngClass]="theme.getThemeClass()" class="min-width-div container-fluid">
    @if (mainContent === 'operator-list') {
    <nav id="search-component" class="filter-group">
        <input #searchBox type="search"  id="search-box" [(ngModel)]="userFilter" (input)="this.search()"
            class="form-control rounded searchInput"
            placeholder="{{ 'userlistSearchInputPlaceHolder' | translate }}" aria-label="Search" aria-describedby="search-addon" />
        <select
          class="form-control ng-select select-filter-by"
          [(ngModel)]="this.filterBy"
          [ngClass]="{ 'has-value': this.filterBy }"
        >
          <option value="">{{ 'filterBy' | translate }}</option>
          @for (option of filterOptions; track option.value) {
            <option [value]="option.value">{{ option.label | translate }}</option>
          }
        </select>
    </nav>
    }

    @if (mainContent === 'operator-list') {
    <header [ngClass]="theme.getThemeClass()" class="table-header">
        <span class="left">{{ "operatorListViewOperatorList" | translate }}</span>
        <span class="right">
          <button [ngClass]="theme.getThemeClass()" class="btn btn-dropdown" id="buttonDropdown" routerLink="/operator-create">
            {{ "newOperator" | translate }}
          </button>
        </span>
      </header>
    }

    <!-- Table container for the user list, shown when mainContent is 'clients' -->
    @if (mainContent === 'operator-list') {
    <section [ngClass]="theme.getThemeClass()" class="table-container">
        <article  class="table-responsive ">
            <table  class="table table-hover">
                <thead >
                    <tr>
                        <th [ngClass]="theme.getThemeClass()" scope="col">
                          {{ 'name' | translate }}
                        </th>
                        <th [ngClass]="theme.getThemeClass()" class="hide-small-screen" scope="col">
                          {{ 'legalName' | translate }}
                        </th>
                        <th [ngClass]="theme.getThemeClass()" scope="col">
                            {{ 'email' | translate }}
                          </th>
                        <th [ngClass]="theme.getThemeClass()" class="hide-small-screen" scope="col">
                          {{ 'phoneNumber' | translate }}
                        </th>
                        <th [ngClass]="theme.getThemeClass()" class="hide-small-screen" scope="col">
                          {{ 'address' | translate }}
                        </th>
                        <th [ngClass]="theme.getThemeClass()" scope="col">
                            {{ 'iotTabHeaderResources' | translate }}
                        </th>
                      </tr>
                </thead>
                @for (operator of this.operator.operator_array; track operator.operator_id) {
                    <tbody>
                        <tr style="vertical-align: middle;">
                            <td [ngClass]="theme.getThemeClass()" [style.color]="(operator.active === '1') ? 'green!important' : 'red!important'">{{ operator.operator_name }}</td>
                            <td [ngClass]="theme.getThemeClass()">{{ operator.legal_name }}</td>
                            <td [ngClass]="theme.getThemeClass()">{{ operator.email }}</td>
                            <td [ngClass]="theme.getThemeClass()">{{ this.formatarNumero(operator.phone_number) }}</td>
                            <td [ngClass]="theme.getThemeClass()" class="hide-small-screen">{{ operator.address }}</td>
                            <td [ngClass]="theme.getThemeClass()">
                                <div class="resource-actions">
                                  <button
                                    type="button"
                                    class="icon-button"
                                    [attr.aria-label]="'Assign clients to ' + operator.operator_name"
                                    (click)="openClientAssignmentModal(operator)"
                                  >
                                    <i class="fa-solid fa-users"></i>
                                  </button>
                                  <a [routerLink]="['/operator-update', operator.operator_id]"><img class="iconUpdate" src="./assets/update-pencil.png" alt="icon of update" height="30" width="30"></a>
                                </div>
                            </td>
                        </tr>
                    </tbody>
                }
            </table>
          </article>
      </section>
    }
    @if (showClientAssignmentModal) {
    <div class="operator-client-modal-backdrop" (click)="closeClientAssignmentModal()">
      <section [ngClass]="theme.getThemeClass()" class="operator-client-modal" (click)="$event.stopPropagation()">
        <header class="operator-client-modal-header">
          <div>
            <h4 class="operator-client-modal-title">{{ 'assignClients' | translate }}</h4>
            <p class="operator-client-modal-subtitle">{{ selectedOperator?.operator_name }}</p>
          </div>
          <button type="button" class="icon-button modal-close-button" (click)="closeClientAssignmentModal()">
            <i class="fa-solid fa-xmark"></i>
          </button>
        </header>

        @if (loadingClientAssignment) {
          <div class="operator-client-modal-state">{{ 'loading' | translate }}</div>
        } @else {
          <div class="operator-client-modal-body">
            <input
              type="search"
              class="form-control rounded searchInput"
              [(ngModel)]="clientAssignmentSearch"
              placeholder="{{ 'search' | translate }}"
              aria-label="{{ 'searchClients' | translate }}"
            />

            <div class="operator-client-tags">
              @for (client of filteredClientSelections; track client.client_id) {
                <label class="operator-client-tag">
                  <input type="checkbox" [(ngModel)]="client.checked">
                  <span>{{ client.client_name }}</span>
                </label>
              }

              @if (filteredClientSelections.length === 0) {
                <p class="operator-client-modal-state">{{ 'noClientsFound' | translate }}</p>
              }
            </div>
          </div>
        }

        <footer class="operator-client-modal-footer">
          <button [ngClass]="theme.getThemeClass()" type="button" class="btn btn-primary btn-block btnCancel fixed-size" (click)="closeClientAssignmentModal()">
            {{ 'cancel' | translate }}
          </button>
          <button
            [ngClass]="theme.getThemeClass()"
            type="button"
            class="btn btn-primary btn-block btnCreate fixed-size"
            [disabled]="loadingClientAssignment || savingClientAssignment"
            (click)="saveClientAssignments()"
          >
            {{ savingClientAssignment ? ('loading' | translate) : ('save' | translate) }}
          </button>
        </footer>
      </section>
    </div>
    }
</div>
